module.exports = __webpack_public_path__ + "img/pexels-christina-morillo-1181345.0cd477d1.jpg";